import { makeLinkComponent } from 'braid-design-system';
import { Link } from 'react-router';

export const CustomLink = makeLinkComponent(({ href, ...restProps }, ref) =>
  href.startsWith('/companies') || href.startsWith('/id/companies') ? (
    <Link ref={ref} to={href} {...restProps} />
  ) : (
    <a ref={ref} href={href} {...restProps} />
  ),
);
